"use strict";

// @file Detect Pixel ratio for platform in the parent module
/* eslint-disable @typescript-eslint/no-var-requires */
Object.defineProperty(exports, "__esModule", {
  value: true
});
const platform_1 = require("@padlet/platform");
let pixelRatio = 2;
if (platform_1.isReactNative) {
  const {
    PixelRatio
  } = require('react-native');
  pixelRatio = Math.ceil(PixelRatio.get());
} else if (typeof window !== 'undefined' && window.devicePixelRatio !== undefined) {
  pixelRatio = Math.ceil(window.devicePixelRatio);
}
exports.default = pixelRatio;